import { DateTime } from "luxon";
import { addDays } from "lib/date";
import { dinamicUrl } from "state/api";
import { getMonthsDifference } from "lib/date";
import { pathOr } from "ramda";
import { useDispatch, useEffect, useGlobal, useRef, useState } from "reactn";
import axios from "axios";
import config from "../network/config";
const { lambdaUri } = config;
const daysApi = axios.create({
	baseURL: `${dinamicUrl}/services/reservations/api/v2/offices`,
});

const uri = lambdaUri;

const baseUrl = `${dinamicUrl}/services/reservations/api/v2/offices`;
const baseUrlV3 = `${uri}/reservations/api/v3`;

export const useCalendar = ({
	maxDays,
	line,
	officeSlug,
	office,
	isCounterDisable,
}) => {
	const [state, setState] = useState({
		data: [],
		loading: true,
		error: null,
		fetch: false,
		blocks: [],
	});
	const [user] = useGlobal("user");
	const handleSetDataTimeBlocksV3 = useDispatch("handleSetDataTimeBlocksV3");
	const currentDate = new Date();
	const timezone = office.timezone || "America/Santiago";
	const targetDate = addDays(currentDate, maxDays);
	const months = getMonthsDifference(currentDate, targetDate) || 0;
	const isAllowRervationsV3 = pathOr(
		false,
		["options", "isAllowRervationsV3"],
		office
	);
	const isCounterDisabledByOffice = pathOr(
		false,
		["options", "isCounterDisabled"],
		office
	);

	const realCounterDisabled = isCounterDisabledByOffice || isCounterDisable;

	const isMounted = useRef(true);

	useEffect(() => {
		if (
			line &&
			office &&
			office.options.reservations_v2 &&
			!state.fetch &&
			!realCounterDisabled &&
			!isAllowRervationsV3
		) {
			setState({ data: [], loading: true, error: null, fetch: true });
			const mothsToFetch = getMonthsArray(months).map((month) => {
				let year = currentDate.getFullYear();

				if (month > 12) {
					month = month - 12;
					year = year + 1;
				}
				return `${baseUrl}/${officeSlug}/${line.slug}/${year}/${month}/timeblocks/counter?tz=${timezone}`;
			});

			fetchMonths(mothsToFetch);
			return;
		}
		if (isAllowRervationsV3) {
			getBlockRange({
				lineSlug: line.slug,
				startDate: DateTime.fromISO(currentDate.toISOString(), {
					zone: timezone,
				}).toUTC(),
				endDate: DateTime.fromISO(currentDate.toISOString())
					.plus({ months })
					.toUTC()
					.endOf("month")
					.toFormat("yyyy-MM-dd"),
			});
		}
		if (realCounterDisabled) {
			setState({ data: [], loading: false, error: null, fetch: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [line, isCounterDisable, isAllowRervationsV3]);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const getMonthsArray = (months) => {
		const currentMonth = currentDate.getMonth() + 1;

		const currentMonthString =
			currentMonth < 10 ? `0${currentMonth}` : `${currentMonth}`;

		const monthsArray = [currentMonthString];

		for (let i = 0; i < months; i++) {
			const month = currentMonth + i + 1;
			const monthString = month < 10 ? `0${month}` : `${month}`;
			monthsArray.push(monthString);
		}

		return monthsArray;
	};

	const fetchBlockRange = async ({ lineSlug, from, to }) => {
		try {
			const { data = [] } = await axios.get(
				`${baseUrlV3}/blocks/${lineSlug}?from=${from}&to=${to}&tz=${timezone}`,
				{
					headers: {
						Authorization: user.token,
					},
				}
			);
			return data.customCode ? [] : data;
		} catch (error) {
			console.log(error);
		}
	};

	const getBlockRange = async ({ lineSlug, startDate, endDate }) => {
		setState((prevState) => ({
			...prevState,
			loading: true,
		}));
		const blockRange = await fetchBlockRange({
			lineSlug,
			from: startDate,
			to: endDate,
		});

		handleSetDataTimeBlocksV3({
			date: new Date(),
			lineSlug,
			officeSlug,
			data: blockRange,
		});

		setState((prevState) => ({
			...prevState,
			blocks: blockRange,
			loading: false,
			error: null,
			fetch: true,
		}));
	};

	const fetchMonths = (months) => {
		axios
			.all(months.map((endpoint) => axios.get(endpoint)))
			.then((data) => {
				if (isMounted.current) {
					setState((prevState) => ({
						...prevState,
						data: data.map((response) => response.data),
						loading: false,
						error: null,
						fetch: true,
					}));
				}
			});
	};

	const getDayBlock = (blocks, date) => {
		if (!blocks) return { bookeable: false, reservationsLimit: 0 };
		const dateDayFormated = DateTime.fromISO(date, { zone: "utc" }).toISO();
		const dayBlock = blocks.find(({ date }) => date === dateDayFormated);

		if (dayBlock && dayBlock.blocks && dayBlock.blocks.length > 0) {
			const { totalSlotsDate } = dayBlock;
			return { bookeable: true, reservationsLimit: totalSlotsDate };
		}
		return { bookeable: false, reservationsLimit: 0 };
	};

	return { ...state, isAllowRervationsV3, getDayBlock };
};
